import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-question-line"></i>
            答疑解惑
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">常见问题</h2>
          <p className="text-foreground-600 text-sm">关于黑料爆料网，你可能想了解的</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, i) => (
            <details
              key={i}
              className="bg-background-100 rounded-xl border border-secondary-200/70 group cursor-pointer"
              open={i < 3}
            >
              <summary className="flex items-center justify-between p-4 md:p-5 list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4 font-heading leading-snug">
                  {item.q}
                </h3>
                <div className="w-6 h-6 rounded-full bg-secondary-200 flex items-center justify-center flex-shrink-0 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                  <i className="ri-arrow-down-s-line text-sm group-open:rotate-180 transition-transform"></i>
                </div>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed pt-1 border-t border-secondary-200">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}